import { Menu, Text } from "@mike/crt";
import { Page } from "../components/Page";

const contactOptions = [
  {
    label: "GITHUB",
    action: () => window.open("https://github.com/Cavallando", "_blank"),
  },
  {
    label: "LINKEDIN",
    action: () =>
      window.open(
        "https://www.linkedin.com/in/michael-cavallaro-5a2130b1/",
        "_blank",
      ),
  },
];

export function ContactPage() {
  return (
    <Page>
      <Text fontSize={42} color="#90d0ff" marginBottom={20}>
        CONTACT
      </Text>
      <Text fontSize={14} color="rgba(100, 160, 200, 0.6)" marginBottom={60}>
        PLEASE TALK TO ME
      </Text>
      <Menu items={contactOptions} />
    </Page>
  );
}
